import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Backdrop } from '../../common-components/Backdrop/Backdrop';
import { OrderDetails } from '../OrderDetails/OrderDetails';

interface IModalOrderDetailsProps {
  visible: boolean;
  close: (orderId?: number) => void;
  title: string;
  orderId?: number;
}

const ModalOrderDetails: React.FC<IModalOrderDetailsProps> = ({
  visible,
  close,
  title,
  orderId
}) => {

  const [modalVisible, setModalVisible] = React.useState<boolean>(false);

  const backdrop = React.useMemo(() => modalVisible ? <Backdrop /> : null, [modalVisible]);

  if (!visible) return null;

  return (
    <Modal
      show={visible}
      onHide={() => clickCloseModal()}
      backdrop="static"
      keyboard={false}
      dialogClassName='modal-full-screen'
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id='modalOrderDetailsBody' style={{ height: '80vh', maxHeight: '80vh', overflowY: 'auto' }}>
        <OrderDetails
          orderId={orderId}
          modalOpened={() => setModalVisible(true)}
          modalClosed={() => setModalVisible(false)}
        />
      </Modal.Body>

      {backdrop}
    </Modal>
  );

  function clickCloseModal() {
    close(orderId);
  }
}

export { ModalOrderDetails };